import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const removeLovedOneEmail = async (email: string) => {
  const response = await mutationExecute({
    variables: {
      email,
    },
    mutation: graphql(`
      mutation RemoveLovedOneEmail($email: String!) {
        removeLovedOneEmail(email: $email)
      }
    `),
  });

  return response.data?.removeLovedOneEmail ?? false;
};
